import React, { useState } from 'react';
import partnerValidationService from '../services/partnerValidationService';
import { toast } from 'react-toastify';

const CompanyPatnerFormModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email_patner_company: '',
    telefono: '',
    number_unidades: '',
    businness_patners: '',
    // Datos bancarios
    banco: '',
    numero_Cuenta: '',
    tipo_Cuenta: '',
    nombre_Titular: '',
    // Datos breve
    type_LLave: '',
    number_LLave: '',
    titular_Breve: ''
  });

  const [isValidatingEmail, setIsValidatingEmail] = useState(false);

  // Validar si los datos bancarios están completos
  const isBankDataComplete = formData.banco.trim() !== '' && 
                             formData.numero_Cuenta.trim() !== '' && 
                             formData.tipo_Cuenta.trim() !== '' && 
                             formData.nombre_Titular.trim() !== '';

  // Validar si los datos de breve están completos
  const isBreveDataComplete = formData.type_LLave.trim() !== '' && 
                              formData.number_LLave.trim() !== '' && 
                              formData.titular_Breve.trim() !== '';

  // Validar si el formulario es válido
  const isFormValid = formData.name.trim() !== '' && 
                      formData.email_patner_company.trim() !== '' && 
                      formData.number_unidades.trim() !== '' &&
                      (isBankDataComplete || isBreveDataComplete);

  const handleSubmit = async () => {
    if (!isFormValid) return;

    try {
      setIsValidatingEmail(true);

      // Validar si el email ya existe
      const validation = await partnerValidationService.validateEmail(formData.email_patner_company);

      if (validation.exists) {
        toast.error(validation.message);
        return;
      }

      // Si el email está disponible, proceder con el submit
      onSubmit({
        ...formData,
        number_unidades: parseInt(formData.number_unidades),
        businness_patners: parseFloat(formData.businness_patners) || 0
      });

      // Limpiar el formulario
      setFormData({
        name: '',
        email_patner_company: '',
        telefono: '',
        number_unidades: '',
        businness_patners: '',
        banco: '',
        numero_Cuenta: '',
        tipo_Cuenta: '',
        nombre_Titular: '',
        type_LLave: '',
        number_LLave: '',
        titular_Breve: ''
      });
      onClose();
    } catch (error) {
      toast.error('Error al validar el email: ' + (error.message || 'Error desconocido'));
    } finally {
      setIsValidatingEmail(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-800">Ingresar Company Patner</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        <div className="p-6">
          {/* Datos Básicos */}
          <h4 className="text-md font-semibold text-gray-700 mb-3">Datos Básicos</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nombre <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Ej: Administradora XYZ"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="contacto@empresa.com"
                value={formData.email_patner_company}
                onChange={(e) => setFormData({ ...formData, email_patner_company: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Teléfono
              </label>
              <input
                type="tel"
                placeholder="3001234567"
                value={formData.telefono}
                onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Número de Unidades <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                placeholder="0"
                min="0"
                value={formData.number_unidades}
                onChange={(e) => setFormData({ ...formData, number_unidades: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                % Negocio
              </label>
              <input
                type="number"
                placeholder="0"
                min="0"
                max="100"
                step="0.01"
                value={formData.businness_patners}
                onChange={(e) => setFormData({ ...formData, businness_patners: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Datos Bancarios */}
          <h4 className="text-md font-semibold text-gray-700 mb-3 mt-6">
            Datos Bancarios {isBankDataComplete && <span className="text-green-600 text-sm">(✓ Completo)</span>}
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Banco
              </label>
              <input
                type="text"
                placeholder="Ej: Bancolombia"
                value={formData.banco}
                onChange={(e) => setFormData({ ...formData, banco: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Número de Cuenta
              </label>
              <input
                type="text"
                placeholder="1234567890"
                value={formData.numero_Cuenta}
                onChange={(e) => setFormData({ ...formData, numero_Cuenta: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Tipo de Cuenta
              </label>
              <select
                value={formData.tipo_Cuenta}
                onChange={(e) => setFormData({ ...formData, tipo_Cuenta: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Seleccionar</option>
                <option value="Ahorros">Ahorros</option>
                <option value="Corriente">Corriente</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nombre Titular
              </label>
              <input
                type="text"
                placeholder="Nombre del titular"
                value={formData.nombre_Titular}
                onChange={(e) => setFormData({ ...formData, nombre_Titular: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Datos Breve */}
          <h4 className="text-md font-semibold text-gray-700 mb-3 mt-6">
            Datos Breve {isBreveDataComplete && <span className="text-blue-600 text-sm">(✓ Completo)</span>}
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Tipo de Llave
              </label>
              <select
                value={formData.type_LLave}
                onChange={(e) => setFormData({ ...formData, type_LLave: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Seleccionar</option>
                <option value="Celular">Celular</option>
                <option value="Email">Email</option>
                <option value="Cedula">Cédula</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Número de Llave
              </label>
              <input
                type="text"
                placeholder="Número o email"
                value={formData.number_LLave}
                onChange={(e) => setFormData({ ...formData, number_LLave: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Titular Breve
              </label>
              <input
                type="text"
                placeholder="Nombre del titular"
                value={formData.titular_Breve}
                onChange={(e) => setFormData({ ...formData, titular_Breve: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
          
        </div>

        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 font-medium transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            disabled={!isFormValid || isValidatingEmail}
            title={!isFormValid ? 'Completa los datos básicos y al menos un método de pago (Banco o Breve)' : ''}
            className={`px-6 py-2 rounded-md font-medium transition-colors flex items-center gap-2 ${
              isFormValid && !isValidatingEmail
                ? 'bg-blue-500 hover:bg-blue-600 text-white cursor-pointer'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            {isValidatingEmail && (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            )}
            {isValidatingEmail ? 'Validando...' : 'Ingresar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyPatnerFormModal;
